export default "__VITE_ASSET__DWjjvVos__"